<template>
  <div class="schoolApplicationStatus">
    <!-- <div class="currentStatus mt-2">
      <span class="grey--text">Status: {{ APPLICATION_STATUS[currentStatus] }}</span>
    </div> -->
    <div class="status-edit mt-2">
      <v-btn color="blue" small outlined  @click.stop="toggleEdit">Change Status</v-btn>
    </div>

    <v-dialog v-model="editing"  >
      <v-card>
         <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Change School Status
        </v-card-title>

          <v-select
            :items="APPLICATION_STATUSES.map((key) => { return { text: APPLICATION_STATUSES_MAP[key], value: key } })"
            v-model="activeState"
            outlined
            dense
            hide-details
            class="mx-3 pt-3"
          ></v-select>

        <v-card-actions class="mt-2 pt-0">
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            text
            @click="editing = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

const IN_PROGRESS = 'IN_PROGRESS'
const IS_COMPLETE = 'IS_COMPLETE'
const APPLIED = 'APPLIED'
const INTERVIEW = 'INTERVIEW'
const REJECTED = 'REJECTED'
const ACCEPTED = 'ACCEPTED'
const HOLD = 'HOLD'

const STATUSES = [
  IN_PROGRESS,
  IS_COMPLETE,
  APPLIED,
  INTERVIEW,
  ACCEPTED,
  HOLD,
  REJECTED,
]

const APPLICATION_STATUS = {
  IN_PROGRESS: 'In Progress',
  IS_COMPLETE: 'Ready to Apply',
  APPLIED: 'Applied',
  INTERVIEW: 'Called for Interview',
  ACCEPTED: 'Accepted',
  HOLD: 'Wait Listed',
  REJECTED: 'Rejected',

}

export default {
  props: ['school'],
  data () {
    return {
      editing: false,
      APPLICATION_STATUS,
      APPLICATION_STATUSES: STATUSES,
      APPLICATION_STATUSES_MAP: APPLICATION_STATUS
    }
  },
  computed : {
    activeState: {
      set (newstatus) {
        this.upsertSchoolAppStatus({ status: newstatus, id: this.school.id })
      },
      get () {
        return this.currentStatus
      }
    },
    user() {
      return this.$store.getters.user;
    },
    currentStatus () {
      if (!this.user.school_applications) return IN_PROGRESS
      if (!this.user.school_applications[this.school.id]) return IN_PROGRESS
      return this.user.school_applications[this.school.id].status ? this.user.school_applications[this.school.id].status : IN_PROGRESS
    }
  },
  methods: {
    ...mapActions(['upsertSchoolAppStatus']),
    toggleEdit () {
      this.editing = !this.editing
    }
  },
  mounted () {
  }
}
</script>

<style >
@media (min-width: 960px) {
   .v-dialog {
    max-width:45%;

  }


}




</style>




// WEBPACK FOOTER //
// src/components/Dashboard/SavedSchools/SchoolApplicationStatus.vue